<template>
  <div>
    <div :class="preview ? 'w-full' : 'w-3/4'">
      <FieldTitle :model="model"/>
    </div>

    <!--Read only-->
    <div v-if="readOnly" :class="preview ? 'w-full' : 'w-3/4'" class="cursor-default">

      <!-- 1. Dropdown with single select-->
      <DropdownSingleSelect :readOnly="true" :model="model" />

      <!-- 2. Dropdown with multiselect-->
      <DropdownMultiSelect :readOnly="true" :model="model" />

      <!-- 3. Checkboxes-->
      <CheckBoxes :readOnly="true" :model="model" />

    </div>

    <!-- Edit mode -->
    <div v-else class="flex">
      <div class="w-full pr-0 xl:w-3/4">
        <div>
          <font-awesome-icon v-show="isSaving" icon="spinner" class="animate-spin absolute right-2.5 top-3"/>
        </div>

        <!-- 1. Dropdown with single select-->
        <DropdownSingleSelect :readOnly="false" :model="model"  :pageId="pageId" />

        <!-- 2. Dropdown with multiselect-->
        <DropdownMultiSelect :readOnly="false" :model="model" :pageId="pageId" />

        <!-- 3. Checkboxes-->
        <CheckBoxes :readOnly="false" :model="model" :pageId="pageId" />

      </div>

      <!--Comments-->
      <div class="hidden w-1/4 pr-0 mb-4 xl:block lg:pl-4">
        <CommentPane
          v-if="!model.deactivateComments"
          :model="model.comments"
          :contentGuid="model.contentGuid"
          :pageId="pageId"
          :fieldTitle="model.title"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CommentPane from '@/views/components/schema/CommentPane.vue';
import FieldTitle from '@/views/components/schema/common/FieldTitle.vue';
import DropdownSingleSelect from '@/views/components/schema/relationSelector/DropdownSingleSelect.vue';
import DropdownMultiSelect from '@/views/components/schema/relationSelector/DropdownMultiSelect.vue';
import CheckBoxes from '@/views/components/schema/relationSelector/CheckBoxes.vue';

export default {
  props: {
    model: {
      type: Object,
      required: true,
    },
    pageId: {
      type: String,
      required: false,
    },
    readOnly: {
      type: Boolean,
      required: false,
    },
    preview: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    DropdownSingleSelect,
    DropdownMultiSelect,
    CheckBoxes,
    CommentPane,
    FieldTitle,
  },
  data() {
    return {
      type: this.model.properties.selectType,
      isSaving: false,
    };
  },
  methods: {},
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>
